import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import fastDeepEqual from 'fast-deep-equal'
import { G } from '@adc/sdk'
import {
  ListingCard,
  withApplicationNotificationsContext,
  getNullApplicationNotifications,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { LISTING_CARD, trackPropertyClick } from '../../services/analytics'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class ListingCardWrapper extends Component {
  static propTypes = {
    listing: PropTypes.object.isRequired,
    elmId: PropTypes.string.isRequired,
    isSaved: PropTypes.bool.isRequired,
    position: PropTypes.number,
    toggleSaveAsset: PropTypes.func.isRequired,
    updateSelectedId: PropTypes.func.isRequired,
    updateOpenedAsset: PropTypes.func.isRequired,
    featureFlags: PropTypes.object.isRequired,
    showAdContent: PropTypes.bool.isRequired,
    isFocused: PropTypes.bool,
    notifications: PropTypes.object.isRequired,
    updateVerifiedImage: PropTypes.func.isRequired,
    verifiedImage: PropTypes.string,
  }

  static defaultProps = {
    notifications: getNullApplicationNotifications(),
  }

  onMouseEnter = e => {
    e.stopPropagation()
    const { listing, updateSelectedId } = this.props
    updateSelectedId(listing.listing_id)
  }

  toggleSaveAsset = (_event, analyticsData = {}) => {
    this.props.toggleSaveAsset({
      listing: this.props.listing,
      updateListingSavedCallback: _.noop,
      ...analyticsData,
      notifications: this.props.notifications,
    })
  }

  onClickAsset = (listingData = {}) => {
    const { updateOpenedAsset, listing } = this.props
    trackPropertyClick({
      listing,
      triggeredFrom: LISTING_CARD,
      ...listingData,
    })
    updateOpenedAsset(listing.listing_id)
  }

  shouldComponentUpdate(nextProps) {
    const isRawAssetEqual = fastDeepEqual(nextProps.listing, this.props.listing)
    const isSavedAssetEqual = fastDeepEqual(
      nextProps.isSaved,
      this.props.isSaved
    )
    return !isRawAssetEqual || !isSavedAssetEqual
  }

  render() {
    const {
      listing,
      elmId,
      position,
      featureFlags = {},
      showAdContent,
      isFocused,
      verifiedImage,
      updateVerifiedImage,
    } = this.props

    const isCancelled =
      listing?.listing_status === G.ListingStatusGroup.Canceled
    const listingId = listing?.listing_id ?? null
    // ad content listing card doesn't require full data
    if (listingId === null && !showAdContent) {
      return null
    }
    return (
      <div
        data-elm-id={`${elmId}_root`}
        data-position={`${position}`}
        className={cx('asset-root')}
        onMouseEnter={this.onMouseEnter}
      >
        <ListingCard
          listing={listing}
          elmId={elmId}
          linkProps={{
            onClick: !isCancelled ? this.onClickAsset : null,
            href: listing.listing_page_path,
          }}
          showSave
          onSaveToggle={!isCancelled ? this.toggleSaveAsset : null}
          showV2
          isCancelled={isCancelled}
          featureFlags={featureFlags}
          isFocused={isFocused}
          showAdContent={Boolean(showAdContent)}
          verifiedImage={verifiedImage}
          updateVerifiedImage={updateVerifiedImage}
        />
      </div>
    )
  }
}

export { ListingCardWrapper }
export default withApplicationNotificationsContext(ListingCardWrapper)
